module.exports = __webpack_public_path__ + "8149566f6eb6c92f17254c5fc112b50b.svg";